module.exports = __webpack_public_path__ + "img/new-logo-gdl.0ad4ac2a.svg";